export default __webpack_public_path__ + "static/media/modern-mirror-logo-black.908435b3.svg";